import { render, staticRenderFns } from "./PendingCampaigns.vue?vue&type=template&id=20e21c32&"
import script from "./PendingCampaigns.vue?vue&type=script&lang=js&"
export * from "./PendingCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./PendingCampaigns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports